import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, Table } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { fromUtcToLocalMoment } from '../utilities/DateHelpers';
import { MomentTimeFormat } from '../MomentTimeFormat';

export default class JobResourceOverrideSpecifics extends React.Component {
    constructor(props) {
        super(props);

        this.state = { showModal: false };
    }

    toggleModal = () => {
        this.setState(({ showModal }) => ({ showModal: !showModal }));
    };

    getLocationText = (locationId, fallbackText) => {
        const { arcGisLocations } = this.props;

        const location = (arcGisLocations || []).find(
            (arcGisLocation) => arcGisLocation.id == locationId
        );

        return location?.addrLoc || fallbackText || '';
    };

    getOriginLocationText = (override) => {
        if (!override) {
            return null;
        }

        if (override.arcGisOriginAddrLoc) {
            return override.arcGisOriginAddrLoc;
        }

        return this.getLocationText(override.arcGisOriginId, override.roadName);
    };

    getDestinationLocationText = (override) => {
        if (!override || !override.arcGisDestinationId) {
            return null;
        }

        return (
            override.arcGisDestinationAddrLoc ??
            this.getLocationText(override.arcGisDestinationId)
        );
    };

    getFilteredJobResourceOverrides = () => {
        const { jobResourceOverrides } = this.props;

        if (!jobResourceOverrides?.length) {
            return [];
        }

        return jobResourceOverrides.filter(
            (jro) => !jro.intendedEmployeeId && !jro.intendedEquipmentId
        );
    };

    render() {
        const { resourceLabel, className } = this.props;
        const { showModal } = this.state;

        const filteredJobResourceOverrides =
            this.getFilteredJobResourceOverrides();

        if (!filteredJobResourceOverrides?.length) {
            return null;
        }

        return (
            <>
                <Button
                    color="success"
                    size="sm"
                    type="button"
                    onClick={this.toggleModal}
                    outline={true}
                    className={className ?? ''}
                >
                    <FontAwesomeIcon
                        icon={faMagnifyingGlass}
                        className="mr-1"
                    />
                    Show {filteredJobResourceOverrides.length} override
                    specifics
                </Button>

                <Modal
                    isOpen={showModal}
                    toggle={this.toggleModal}
                    size="lg"
                    fade={false}
                >
                    <ModalHeader toggle={this.toggleModal}>
                        {resourceLabel} Override Specifics
                    </ModalHeader>
                    <ModalBody>
                        <Table size="sm" responsive>
                            <thead>
                                <tr>
                                    <th>Start Time</th>
                                    <th>Start Location</th>
                                    <th>Destination</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredJobResourceOverrides.map(
                                    (override, index) => (
                                        <tr key={override.id || index}>
                                            <td>
                                                {override.startTime
                                                    ? fromUtcToLocalMoment(
                                                          override.startTime
                                                      ).format(
                                                          MomentTimeFormat.AnteTwelveHour
                                                      )
                                                    : ''}
                                            </td>
                                            <td>
                                                {this.getOriginLocationText(
                                                    override
                                                )}
                                            </td>
                                            <td>
                                                {this.getDestinationLocationText(
                                                    override
                                                )}
                                            </td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </Table>
                    </ModalBody>
                </Modal>
            </>
        );
    }
}
